import { useEffect } from "react";

const RouteWithTitle = ({ element, title, description }) => {
  useEffect(() => {
    document.title = `${title} - Sparronix`;

    // Meta description
    let metaDesc = document.querySelector("meta[name='description']");
    if (!metaDesc) {
      metaDesc = document.createElement("meta");
      metaDesc.name = "description";
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = description || title;

    // Open Graph title
    let ogTitle = document.querySelector("meta[property='og:title']");
    if (!ogTitle) {
      ogTitle = document.createElement("meta");
      ogTitle.setAttribute("property", "og:title");
      document.head.appendChild(ogTitle);
    }
    ogTitle.setAttribute("content", `${title} - Sparronix`);
  }, [title, description]);

  return element;
};

export default RouteWithTitle;
